import { axios } from "../../utils/axiosBase";
import {
  FETCH_PARENT_CATEGORY_PACKAGE_DETAIL,
  LOAD_PARENT_CATEGORY_PACKAGE_DETAIL,
} from "./types";

const fetchParentCategoryPackageDetail =
  (currentLang, userId, parent_category_id, history) =>
  async (dispatch, getState) => {
    const payload = {
      currentLang: currentLang,
      userId: userId,
    };

    // chiamo web service
    const response = await axios.post(
      `api/parentcategorypackagedetail/${parent_category_id}/`,
      payload,
      {
        withCredentials: true,
      }
    );

    dispatch({
      type: FETCH_PARENT_CATEGORY_PACKAGE_DETAIL,
      payload: response.data,
    });
  };

const loadParentCategoryPackageDetail =
  (parentCategoryLoaded, history) => async (dispatch, getState) => {
    dispatch({
      type: LOAD_PARENT_CATEGORY_PACKAGE_DETAIL,
      payload: {
        parentCategoryLoaded,
      },
    });
  };

export default {
  fetchParentCategoryPackageDetail,
  loadParentCategoryPackageDetail,
};
